import { useAccountStore } from "@/composables/account/useAccountStore";
import type { AccountUpdateResult } from "@/types";
import { ref } from "vue";

export interface InternationalSignupData {
  // Required by the backend (validated/present on the frontend before submit).
  account_name: string;
  phone_number: string;
  name: string;
  registry_code: string;
  address: string;
  vat: string | null;
  country: string;
}

export function useInternationalSignup() {
  const accountStore = useAccountStore();
  const loading = ref(false);

  // Errors are surfaced by the caller, which can distinguish a 409 (duplicate company on
  // re-entry) from unexpected failures — see InternationalSignupFlow.handleSubmit.
  const createCompany = async (
    data: InternationalSignupData
  ): Promise<AccountUpdateResult> => {
    loading.value = true;
    try {
      return await accountStore.postAccountChange(
        "/api/signup/international/company",
        data
      );
    } finally {
      loading.value = false;
    }
  };

  return {
    loading,
    createCompany,
  };
}
